import { TextInput } from "@Modules/common/Form";
import ShippingIcon from "@mui/icons-material/LocalShippingRounded";
import WarningIcon from "@mui/icons-material/WarningAmberRounded";
import { Button } from "@mui/material";
import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import { DetailsSectionDivider } from "../DetailsSectionDivider";
import styles from "./checkAvailability.module.scss";
import { ICheckAvailability } from "./ICheckAvailability";
import useCheckAvailability from "./useCheckAvailability";

const CheckAvailability: FC<ICheckAvailability.IProps> = props => {
    const { className, showBottonDivider } = props;

    const {
        pincode,
        error,
        showError,
        servicable,
        handleChange,
        handleBlur,
        handleCheckEstimate,
        hideComponent,
        shiprocketEnabled,
    } = useCheckAvailability(props);

    if (hideComponent) {
        return null;
    }

    return (
        <>
            <div className={className}>
                {/* check serviceability in user pincode in case of shiprocket */}
                {shiprocketEnabled && (
                    <div className={styles.root}>
                        <div className={styles.inputWrapper}>
                            <TextInput
                                className={styles.input}
                                placeholder="Enter Pincode to check availability"
                                value={pincode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={showError && !!error}
                                onKeyDown={(e: React.KeyboardEvent) => {
                                    if (e.key === "Enter")
                                        handleCheckEstimate();
                                }}
                            />
                        </div>
                        <Button
                            className={styles.cta}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleCheckEstimate}
                        >
                            Check
                        </Button>
                    </div>
                )}

                {showError && error && (
                    <div className={styles.error}>
                        <WarningIcon /> <span>{error}</span>
                    </div>
                )}

                {servicable.message &&
                    (servicable.status ? (
                        <div
                            className={classNames(
                                styles.servicable,
                                !shiprocketEnabled && styles.noMargin
                            )}
                        >
                            <ShippingIcon /> {servicable.message}
                        </div>
                    ) : (
                        <div
                            className={classNames(
                                styles.serviceError,
                                !shiprocketEnabled && styles.noMargin
                            )}
                        >
                            <WarningIcon />
                            {servicable.message}
                        </div>
                    ))}
            </div>

            {showBottonDivider && <DetailsSectionDivider />}
        </>
    );
};

export default CheckAvailability;
